import {
  getList,
  LeoRPCRequest,
  LeoRPCResponse,
  LeoRPCResult,
  LeoRPC
} from "@surya-digital/leo-ts-types";
import { APIKeyManagementProject, APIKeyManagementProjectDTO } from "./apiKeyManagementProject";
/* eslint-disable import/export */
export abstract class GetActiveProjectsForAPIKeyManagementRPC implements
  LeoRPC<GetActiveProjectsForAPIKeyManagementRPC.Request, GetActiveProjectsForAPIKeyManagementRPC.Response, GetActiveProjectsForAPIKeyManagementRPC.Errors.Errors>
{
  abstract execute(
    request: GetActiveProjectsForAPIKeyManagementRPC.Request
  ): Promise<LeoRPCResult<GetActiveProjectsForAPIKeyManagementRPC.Response, GetActiveProjectsForAPIKeyManagementRPC.Errors.Errors>>;
}

export namespace GetActiveProjectsForAPIKeyManagementRPC {

  export class InvalidRequestError extends Error {
    constructor(message?: string) {
      super(message);
      Object.setPrototypeOf(this, new.target.prototype);
      this.name = "InvalidRequestError";
    }
  }

  export interface RequestDTO {}

  export class Request implements LeoRPCRequest {
    readonly isGetActiveProjectsForAPIKeyManagementRPCRequest: boolean = true;
    toDTO(): RequestDTO {
      return {}
    }
  }

  Request.prototype.toString = function toString(): string {
    return `GetActiveProjectsForAPIKeyManagementRPC.Request`;
  };

  export class InvalidResponseError extends Error {
    constructor(message?: string) {
      super(message);
      Object.setPrototypeOf(this, new.target.prototype);
      this.name = "InvalidResponseError";
    }
  }

  export interface ResponseDTO {
    projects: APIKeyManagementProjectDTO[];
  }
  
  export class Response implements LeoRPCResponse {
    readonly isGetActiveProjectsForAPIKeyManagementResponse: boolean = true;
  
    readonly projects: APIKeyManagementProject[];
  
  
    constructor(
    projects: APIKeyManagementProject[]
    ) {
      this.projects = projects;
    }
  
    static fromDTO(dto: ResponseDTO): Response {
      const projects = getList<APIKeyManagementProjectDTO, APIKeyManagementProject>(
        dto,
        "projects",
        APIKeyManagementProject.fromDTO,
        InvalidResponseProjectsError
      );
      return new Response(
        projects
      );
    }
  
    toDTO(): ResponseDTO {
      const dto: ResponseDTO = {
          projects: this.projects.map((e: APIKeyManagementProject) => { return e.toDTO() })
      };
      return dto;
    }
    }
  
  Response.prototype.toString = function toString(): string {
    return `GetActiveProjectsForAPIKeyManagement(projects='${this.projects}')`;
  };
  


  export namespace Errors {

    export type Errors = any;
    export type ErrorsDTO = any;

    export const fromDTO = (dto: ErrorsDTO): Errors => {
      switch (dto.code) {
        default:
          throw new InvalidResponseError(`Unexpected error code: ${dto.code}`);
      }
    };
  }
}


export class InvalidResponseProjectsError extends GetActiveProjectsForAPIKeyManagementRPC.InvalidResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidResponseProjectsError";
  }
}

